import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";
import { ActionSkeleton, DetailsCardSkeleton, ExchangeDetailsSkeleton } from "./PointsExchangeSkeleton.shared";

export default function PointsExchangeSkeletonWeb() {
  return (
    <div className="flex w-full items-start gap-10">
      <div className="flex-2 rounded-xs flex flex-col gap-6 p-6 shadow-sm">
        <DetailsCardSkeleton />
        <ExchangeDetailsSkeleton />
        <ActionSkeleton />
      </div>
      <div className="rounded-xs flex flex-1 flex-col shadow-sm">
        <div className="border-border-subtle flex items-center gap-3 border-b p-4">
          <SkeletonBox className="size-10 shrink-0 rounded-full" />
          <SkeletonBox className="h-5 w-36" />
        </div>
        <div className="flex flex-col gap-3 p-4">
          <SkeletonBox className="h-3 w-full" />
          <SkeletonBox className="h-3 w-full" />
          <SkeletonBox className="h-3 w-4/5" />
          <SkeletonBox className="h-3 w-full" />
          <SkeletonBox className="h-3 w-2/3" />
          <SkeletonBox className="h-3 w-full" />
          <SkeletonBox className="h-3 w-3/4" />
        </div>
      </div>
    </div>
  );
}
